import React from "react";

// Brand mark: three stacked angled strokes (navy, teal, gold) echoing the Founder+ logo
export function LogoMark({ className = "h-9 w-9" }) {
  return (
    <svg viewBox="0 0 48 48" className={className} fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path d="M10 8 H38 L32 16 H10 Z" fill="#0B1F3A" />
      <path d="M10 20 H32 L26 28 H10 Z" fill="#138A72" />
      <path d="M10 32 L22 32 L10 44 Z" fill="#C9A35B" />
    </svg>
  );
}

export default function Logo({ inverse = false, tagline = true, className = "" }) {
  const ink = inverse ? "#FFFFFF" : "#0B1F3A";
  const sub = inverse ? "rgba(255,255,255,0.62)" : "rgba(34,34,34,0.55)";
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <LogoMark className="h-9 w-9 shrink-0" />
      <div className="leading-none">
        <div className="font-heading font-extrabold tracking-tight text-[22px]" style={{ color: ink }}>
          Founder<span style={{ color: "#C9A35B" }}>+</span>
        </div>
        {tagline && (
          <div
            className="mt-1 text-[9px] font-semibold uppercase tracking-[0.24em]"
            style={{ color: sub }}
          >
            The Company Building Partner
          </div>
        )}
      </div>
    </div>
  );
}
